/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    useState,
  } from 'react';

import { RequestSupport } from './RequestSupport';

const SupportOption = ({
  originType = '',
  originId = '',
  canCancel = false,
  phone = '',
  cancelTitle = '',
  cancel,
}) => {
  const [openRequestSupport, setOpenRequestSupport] = useState<any>(false);

  return (
    <>
      <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
        <thead>
          <tr className='border-0'>
            <th className='p-0'></th>
          </tr>
        </thead>
        <tbody>
          {canCancel && <tr onClick={() => cancel && cancel(true)}>
            <td>
              <span className='text-hover-primary text-gray-900 fw-bold mb-1 fs-6 cursor-pointer'>
                <i className="las la-angle-right fw-bold fs-2 text-white text-gray-900 me-2" /> {cancelTitle}
              </span>
            </td>
          </tr>}

          {phone && <tr onClick={() => window.open(`https://wa.me/${phone}`, '_blank')}>
            <td>
              <span className='text-hover-primary text-gray-900 fw-bold mb-1 fs-6 cursor-pointer'>
                <i className="las la-angle-right fw-bold fs-2 text-white text-gray-900 me-2" /> Preciso falar com a unidade
              </span>
            </td>
          </tr>}

          <tr onClick={() => setOpenRequestSupport(true)}>
            <td>
              <span className='text-hover-primary text-gray-900 fw-bold mb-1 fs-6 cursor-pointer'>
                <i className="las la-angle-right fw-bold fs-2 text-white text-gray-900 me-2" /> Preciso falar com o suporte
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <RequestSupport
        originId={originId}
        originType={originType}
        isOpen={openRequestSupport}
        onClosed={() => setOpenRequestSupport(false)}
        isLoading={false}
      />
    </>
  )
}

export default SupportOption;
